var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNophoto = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 220,
    viewBox: "0 0 320 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 220,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.643 109.304L159.293 79.7297C159.682 79.3286 160.324 79.3235 160.718 79.7184L190.293 109.293C190.923 109.923 190.477 111 189.586 111H186V140C186 140.552 185.552 141 185 141H169C168.448 141 168 140.552 168 140V119H152V140C152 140.552 151.552 141 151 141H135C134.448 141 134 140.552 134 140V111H131.361C130.478 111 130.028 109.939 130.643 109.304Z",
    fill: "#CCCCCC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNophoto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nophoto.3398cd1118a87663ebe75ee75bfcc851.svg";